import { createStore, compose, Store, Middleware, applyMiddleware, AnyAction } from 'redux';
import thunk from 'redux-thunk';
import { createActionLogger } from './middleware/actionLoggerMiddleware';
import { routeMiddleware } from './middleware/routeMiddleware';
import { lpcDataUpdateMiddleware } from './middleware/lpcDataUpdateMiddleware';
import { immutable } from './middleware/reduxImmutableStateInvariant';
import { exceptionHandlerMiddleware } from './middleware/exceptionHandlerMiddleware';
import { getAppStateReducer, appStatePackageStateKey } from 'people/lib/appstate';
import { getAppChromeStateReducer, appChromePackageStateKey } from 'people/lib/appchrome';
import { Logger, registerReducer, isDev } from 'people/lib/shared';

let store: Store<{}, AnyAction>;

export default function configureStore(logger: Logger): Promise<Store<{}, AnyAction>> {
    const composeEnhancers = window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] || compose;
    const middlewares: Middleware[] = [
        exceptionHandlerMiddleware,
        thunk,
        createActionLogger(logger),
        routeMiddleware,
        lpcDataUpdateMiddleware,
    ];

    if (isDev()) {
        middlewares.push(immutable());
    }

    store = createStore(
        () => undefined,
        undefined,
        composeEnhancers(applyMiddleware(...middlewares))
    );

    const appStateReducerPromise = getAppStateReducer().then(appStateReducer => {
        // Need to register the appState reducer before returning the store
        // as store.getState() will be undefined until a reducer is registered.
        registerReducer(store, appStatePackageStateKey, appStateReducer);
    });
    const appChromeReducerPromise = getAppChromeStateReducer().then(appChromeReducer => {
        registerReducer(store, appChromePackageStateKey, appChromeReducer);
    });

    return Promise.all([appStateReducerPromise, appChromeReducerPromise]).then(() => store);
}

export const getStore = () => store;
